import cx from 'classnames'
import { Link } from 'react-router-dom'
import { Dataset } from '~/api/onPremAgent/datasetsAPI'
import RightArrowIcon from '~/components/icons/RightArrowIcon'
import { getPlateBarcode, getRelativeDetectedTime } from './DatasetsTable'
import cs from './dataset_breadcrumbs.scss'

export default function DatasetBreadcrumbs({
  className,
  dataset,
  currentPageLabel,
}: {
  className?: string
  dataset?: Dataset
  currentPageLabel?: string
}) {
  return (
    <nav className={cx(cs.breadcrumbs, className)}>
      <Link key='root' to='/datasets'>
        Datasets
      </Link>
      {dataset ? (
        <DatasetCrumb dataset={dataset} />
      ) : currentPageLabel ? (
        <TrailingLabel label={currentPageLabel} />
      ) : null}
    </nav>
  )
}

function DatasetCrumb({ dataset }: { dataset: Dataset }) {
  return (
    <>
      <RightArrowIcon key='platesep' className={cs.separator} />
      <Link key='root' to={`/datasets/${dataset.uuid}`}>
        {getPlateBarcode(dataset) || dataset.uuid} (detected{' '}
        {getRelativeDetectedTime(dataset)})
      </Link>
    </>
  )
}

function TrailingLabel({ label }: { label: string }) {
  return (
    <>
      <RightArrowIcon key='breadcrumbsep' className={cs.separator} />
      <span className={cs.activeLabel}>{label}</span>
    </>
  )
}
